export enum ReportTableRowDataSource
{
    None,
    UseExisting,
    Day,
    Week,
    Driver,
    Vehicle,
    DriverGroup,
    VehicleGroup,
    Journey,
    Geofence,
    Route,
    TemperatureRecord,
    StationaryLocations,
    GeofenceVisits,
    TrailerAssociation,
    CommonEvent,
    TachoRecord,
    AlcolockRecord,
    RoadType,
    TemperatureOutOfBoundsRecord,
    VehicleInput,
    Tag,
    CameraEvent,
    VehicleDepot,
    FormSubmission
}
